export default __webpack_public_path__ + "static/media/logo_Circulo.af05ecb4.png";